{
  "version": 1,
  "asset_id": "602fafc5-9402-45e2-a5e3-b52fcb9070be",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/602fafc5-9402-45e2-a5e3-b52fcb9070be/ind-professional-services-1200.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/602fafc5-9402-45e2-a5e3-b52fcb9070be/ind-professional-services-1200.avif",
  "original_filename": "ind-professional-services-1200.avif",
  "size": 12601,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:10Z"
}
